<wd-simple-layout label="Bohrpunktliste">
	<div list-element class="left-split">
		<bp-bohrpunkt-list-panel
			[bps]="bps"
			[pointsFilter]="pointsFilter"
			[boundsFilter]="boundsFilter"
			[currentBounds]="currentBounds"
			[activeId]="active"
			(pointSelected)="select($event.event, $event.bp)"
			(pointsDeleted)="initPoints()">
		</bp-bohrpunkt-list-panel>
	</div>
	<div content-element class="content-wrapper">
		<router-outlet></router-outlet>
	</div>
</wd-simple-layout>
